import React, {useMemo} from 'react'

import {
    Box,
    Flex,
    Heading,
    Image,
    Text,
    useMediaQuery
} from '@salesforce/retail-react-app/app/components/shared/ui'

import PropTypes from 'prop-types'
import ProductPricing from '../../../components/product-pricing'
import Link from '../../../components/link'
import {colors} from '../../../constants'
import {contentfulMediaFormatter} from '../../../utils'
import {productUrlBuilder} from '@salesforce/retail-react-app/app/utils/url'

const HomeScrollerCard = ({product}) => {
    const brand = product?.brand?.fields
    const images = contentfulMediaFormatter(product?.image)
    const url = productUrlBuilder({
        id: product?.fallbackProductId || product?.productId
    })

    const [isDesktop] = useMediaQuery('(min-width: 992px)')
    const image =
        !isDesktop && images?.mobile?.url ? images?.mobile : images?.desktop

    return (
        <Box width="100%" minWidth="150px">
            <Link
                url={url}
                width="100%"
                height="auto"
                type="tertiary"
                title={product?.name}
            >
                {image && (
                    <Box marginBottom="16px">
                        <Image
                            src={image?.url}
                            alt={product?.name}
                            objectFit="cover"
                            style={{
                                minHeight: {
                                    base: 'auto',
                                    xl: '197px'
                                },
                                height: '247px',
                                width: '202px'
                            }}
                        />
                    </Box>
                )}

                <Flex flexFlow="column" gap="4px" marginBottom="8px">
                    {brand?.name && (
                        <Text
                            color={colors.black}
                            fontSize="12px"
                            fontWeight="500"
                            lineHeight="20px"
                            fontFamily="Raleway"
                        >
                            {brand?.name}
                        </Text>
                    )}

                    {product?.name && (
                        <Heading
                            as="h3"
                            color={colors.black}
                            fontSize="14px"
                            fontWeight="400"
                            lineHeight="20px"
                            fontFamily="Raleway"
                            _hover={{
                                textDecoration: 'underline'
                            }}
                        >
                            {product?.name}
                        </Heading>
                    )}
                </Flex>

                {product && (
                    <ProductPricing
                        product={product}
                        scope="tile"
                        priceStyling={{
                            color: colors.black,
                            fontFamily: 'Roboto',
                            fontSize: '12px',
                            fontWeight: 500,
                            lineHeight: '20px'
                        }}
                    />
                )}
            </Link>
        </Box>
    )
}

HomeScrollerCard.propTypes = {
    product: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        fallbackProductId: PropTypes.string,
        productId: PropTypes.string,
        c_extend: PropTypes.shape({
            c_productsUniqueName_EN: PropTypes.string,
            c_productsUniqueName_FR: PropTypes.string
        }),
        brand: PropTypes.shape({
            fields: PropTypes.shape({
                type: PropTypes.string,
                required: PropTypes.bool,
                placeholder: PropTypes.string,
                errorMessage: PropTypes.string
            })
        }),
        sectionType: PropTypes.string,
        image: PropTypes.object,
        cta: PropTypes.object
    })
}

export default HomeScrollerCard
